import { ApiDataContext } from "contexts/ApiDataContext";
import { useAutocomplete } from "hooks/forms/FormHooks";
import { useCheckBox, useManagementTextField } from "hooks/forms/ManagementHooks";
import { useLoadingToast } from "hooks/toast/toasts";
import { useContext, useState, useEffect } from "react";

const usePowerDistributionCompanyForm = (initialPowerDistributionId) => {
  const { apiData } = useContext(ApiDataContext);
  const { initializeLoadingToast, updateLoadingToast } = useLoadingToast();

  const [powerDistributionCompanyValue, setPowerDistributionCompanyValue] = useState("");

  const { reset: resetPdcName, ...powerDistributionCompanyName } = useManagementTextField("");
  const { reset: resetPrice, ...price } = useManagementTextField("");
  const { reset: resetState, ...state } = useAutocomplete("", false);
  const { reset: resetEngineer, ...engineer } = useAutocomplete("", false);

  const hasProcessing = useCheckBox(false);
  const hasADifferentPrice = useCheckBox(false);

  const loadData = (_data) => {
    if (_data) {
      powerDistributionCompanyName.onCustomChange(_data.powerDistributionCompanyName);
      price.onCustomChange(_data.price);
      hasProcessing.onCustomChange(_data.hasProcessing);
      hasADifferentPrice.onCustomChange(_data.hasADifferentPrice);
      state.onCustomChange(_data.state);
      engineer.onCustomChange(_data.engineer);
    }
  };

  const handlePowerDistributionCompanyChange = async (event, newValue) => {
    setPowerDistributionCompanyValue(newValue);

    const data = {
      powerDistributionCompanyName: newValue.name,
      price: newValue.price,
      hasProcessing: newValue.processing === 1,
      hasADifferentPrice: newValue.isArtDifferent === 1,
      state: newValue.states,
      engineer: newValue.engineers,
      powerDistributionCompany: newValue,
    };

    loadData(data);
  };

  // Carregar concessionária automaticamente quando initialPowerDistributionId for fornecido
  useEffect(() => {
    if (initialPowerDistributionId && apiData.powerDistributionCompanies) {
      const powerDistributionCompany = apiData.powerDistributionCompanies.find(pdc => pdc.id === initialPowerDistributionId);
      if (powerDistributionCompany && powerDistributionCompany.id !== powerDistributionCompanyValue?.id) {
        handlePowerDistributionCompanyChange(null, powerDistributionCompany);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialPowerDistributionId, apiData.powerDistributionCompanies]);

  const powerDistributionCompany = {
    value: powerDistributionCompanyValue,
    onChange: handlePowerDistributionCompanyChange,
  };

  const values = () => {
    return {
      powerDistributionCompanyName: powerDistributionCompanyName.value,
      price: price.value,
      hasProcessing: hasProcessing.checked,
      hasADifferentPrice: hasADifferentPrice.checked,
      state: state.value,
      engineer: engineer.value,
      powerDistributionCompany: powerDistributionCompany.value,
    };
  };

  const clearAllFields = () => {
    resetPdcName();
    resetState();
    resetPrice();
    resetEngineer();
  };

  return {
    powerDistributionCompany,
    apiPowerDistributionCompanies: apiData.powerDistributionCompanies,

    state,
    apiStates: apiData.states,

    engineer,
    apiEngineers: apiData.engineers,

    powerDistributionCompanyName,
    hasProcessing,
    hasADifferentPrice,
    price,

    initializeLoadingToast,
    updateLoadingToast,

    loadData,
    values,
    clearAllFields,
  };
};

export default usePowerDistributionCompanyForm;
